import { RootState } from '../rootReducer';

export const selectUserInput = (state: RootState) => state.userInput.userInput.userInput;
